import { render } from "./UniSwapTrade.vue?vue&type=template&id=59a48ff4"
import script from "./UniSwapTrade.vue?vue&type=script&lang=js"
export * from "./UniSwapTrade.vue?vue&type=script&lang=js"

import "./UniSwapTrade.vue?vue&type=style&index=0&id=59a48ff4&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__